import React, { Component } from "react";
import { ReactComponent as ConversationIcon } from "../../../assets/images/chat.svg";
import { ReactComponent as CloseIcon } from "../../../assets/images/close.svg";
import { FormattedMessage } from "react-intl";

import "./style.scss";

class Header extends Component {
  render() {
    const { theme, onClose } = this.props;
    return (
      <div className="sc-header">
        <div className="close-container cursor">
          <CloseIcon
            onClick={onClose}
            height="15"
            width="15"
            style={{ fill: "#262626" }}
          />
        </div>

        <div className="d-flex chat-icon-container">
          <ConversationIcon
            className="sc-header--img"
            height="22"
            width="22"
            style={{ fill: "var(--primary-color)" }}
          />
          <div className="sc-header--team-name">
            <FormattedMessage id="chat" defaultMessage="chat" />
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
